import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1606756812/src/client-juicyllama/www/layouts/default.vue").then(m => m.default || m))
}